module.exports = __webpack_public_path__ + "ee563b1a04e714e3f7e2f8eacd6b638f.png";